export const TokenName = 'shiawanAdmin'
export const TenantSlugKey = 'shiawanTenantSlug'



// WEBPACK FOOTER //
// ./src/app/config/app.config.ts